import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "./i18n";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Suppress harmless ResizeObserver loop errors (Chrome dev tools false positive)
const RO_MSG = 'ResizeObserver loop';
const origError = window.onerror;
window.onerror = (msg, ...args) => {
  if (typeof msg === 'string' && msg.includes(RO_MSG)) return true;
  if (origError) return origError(msg, ...args);
};
window.addEventListener('error', (e) => {
  if (e?.message && e.message.includes(RO_MSG)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);
window.addEventListener('unhandledrejection', (e) => {
  if (e?.reason?.message && e.reason.message.includes(RO_MSG)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

// Wrap ResizeObserver itself so dev-server overlay never sees the loop notifications.
// This is the most reliable fix because webpack-dev-server overlay listens via its own iframe.
if (typeof window !== 'undefined' && window.ResizeObserver) {
  const NativeRO = window.ResizeObserver;
  window.ResizeObserver = class WrappedResizeObserver extends NativeRO {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          try { callback(entries, observer); } catch (_) { /* swallow RO loop benign errors */ }
        });
      });
    }
  };
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
